import { BASE_URL } from '@/config/serverApiConfig';
import { formatName } from '@/utils/nameFormatter';

export function getFullName(person) {
    if (!person) return '';
    if (person.fullName) return formatName(person.fullName);
    const parts = [person.name, person.surname].filter(Boolean);
    const name = parts.join(' ').trim() || person.name || person.email || '';
    return formatName(name);
}

export function getInitials(personOrName = '') {
    const name = typeof personOrName === 'string' ? personOrName : getFullName(personOrName);
    return name.split(' ').filter(Boolean).map((part) => part[0]).join('').toUpperCase().slice(0, 2) || '?';
}

export function getPhotoUrl(photo) {
    if (!photo) return null;
    if (/^https?:\/\//i.test(photo)) return photo;
    const relative = photo.startsWith('/') ? photo : `/public/uploads/admin/${photo}`;
    const base = (BASE_URL || '').replace(/\/$/, '');
    return `${base}${relative}`;
}
